// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!/builds/lobaro/iot-dashboard/node_modules/mocha-loader/node_modules/css-loader/index.js!/builds/lobaro/iot-dashboard/node_modules/mocha/mocha.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!/builds/lobaro/iot-dashboard/node_modules/mocha-loader/node_modules/style-loader/addStyles.js")(content, {});
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	module.hot.accept("!!/builds/lobaro/iot-dashboard/node_modules/mocha-loader/node_modules/css-loader/index.js!/builds/lobaro/iot-dashboard/node_modules/mocha/mocha.css", function() {
		var newContent = require("!!/builds/lobaro/iot-dashboard/node_modules/mocha-loader/node_modules/css-loader/index.js!/builds/lobaro/iot-dashboard/node_modules/mocha/mocha.css");
		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
		update(newContent);
	});
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha-loader/~/style-loader!./~/mocha-loader/~/css-loader!./~/mocha/mocha.css
 ** module id = 111
 ** module chunks = 1
 **/